// {
//   "": "1111, 1111",
//   "arztNr": "",
//   "zimmerNr": "",
//   "altPat": 0,
//   "labNr": 1,
//   "info6": "",
//   "info7": "",
//   "info8": "LABOR",
//   "info9": "",
//   "sexPat": "---",
//   "mikroAttrib3": "",
//   "mikroAttrib2": "",
//   "mikroAttrib5": "",
//   "mikroAttrib4": "",
//   "eindat": "29/01/2016 14:00",
//   "auftrNr": "166093451",
//   "info1": "",
//   "info2": "",
//   "info3": "",
//   "notFall": "S",
//   "errorNr": 0,
//   "statusL": "L",
//   "info4": "2016.01.29 14:16",
//   "info5": "",
//   "info10": "",
//   "abnahmeDatum": "-",
//   "errorMsg": "",
//   "labName": "General",
//   "freiTextNr": 0,
//   "attrib5": "",
//   "diagnoseLibre": "",
//   "attrib4": "",
//   "attrib3": "",
//   "gebDat": "30/03/2015",
//   "attrib2": "",
//   "attrib1": "",
//   "aZ": "1111",
//   "statName": "CDB GENERAL",
//   "diagnose": ""
// }

import { ItemConfig } from "./patient-request-detail.component";

export const defaultHeaderConfig: ItemConfig[] = [
  {
    key: 'auftrNr',
    span: 2
  },
  {
    key: 'einDat',
    span: 3
  },
  {
    key: 'info4',
    span: 3,
    pipe: (value: string) => {
      // Convert to date format DD/MM/YYYY HH:mm from YYYY.MM.DD HH:mm
      // check if the format is YYYY.MM.DD HH:mm
      if (!/^\d{4}\.\d{2}\.\d{2} \d{2}:\d{2}$/.test(value)) {
        return value; // Return the original value if it doesn't match the expected format
      }
      const date = new Date(value.replaceAll('.', '/'));
      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const year = date.getFullYear();
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      return `${day}/${month}/${year} ${hours}:${minutes}`;
    }
  },
  {
    key: 'notFall',
    span: 2
  },
  {
    key: 'statName',
    span: 2
  },
  {
    key: 'info9',
    span: 4
  },
  {
    key: 'arztName',
    span: 4
  },
  {
    key: 'arztNr',
    span: 4
  },
  {
    key: 'zimmerNr',
    span: 4
  },
  {
    key: 'diagnose',
    span: 6
  },
  {
    key: 'info1',
    span: 6
  }
]
